import style from './Marquee.module.css';

export default function Marquee() {
  const reviews = [
      {
          text: "«Ми тепер маємо можливість вчасно реагувати та актуалізувати стратегічні цілі, поставлені на початку року. Швидше та якісніше тестувати ключові гіпотези та відслідковувати, як команда досягає поставлених результатів.»",
          img: '/images/reviews/karina.png',
          name: "Каріна Д.",
          position: "CEO and Founder BACKSTAGE"
      },
      {
          text: "«Тепер легше бачити прогрес в досягнені цілей, дизайн дуже крутий та простий для використання. Така візуалізація допомагає в комунікації всередині команди і плануванні роботи.»",
          img: '/images/reviews/iryna.png',
          name: "Ірина П.",
          position: "COO Stop Sexting"
      },
      {
          text: "«Простий та зрозумілий продукт. СЕО дуже добре сприймає візуал — на мій погляд, все інформативно.»",
          img: '/images/reviews/avatar.png',
          name: "Михайло К.",
          position: "COO iSolar"
      },
      {
          text: "«Дуже сподобалось, що реєстрація максимально проста. Інтерфейс легкий, приємний і зрозумілий. Продукт має суперпросту адаптацію — можна почати користуватись одразу без зайвих кроків.»",
          img: '/images/reviews/veronika.jpg',
          name: "Вероніка С.",
          position: "Co-founder & CMO Matcher"
      },
      {
          text: "«Завдяки продукту я переглянула своє ставлення до методології OKR і бачу від інструменту велику користь для нашої команди та організації. Фаундери OKBoard піклуються не лише про інструмент як про продукт, але й про системність, досвід та результати його використання.»",
          img: '/images/reviews/sasha.jpeg',
          name: "Саша Н.",
          position: "СОО Endeavor"
      },
  ];

  const render = () => reviews.map((r, i) => (
    <div key={i} className={style.marqueeItem}>
      <p className={style.reviewText}>{r.text}</p>
      <div className={style.reviewBottom}>
        <img src={r.img} alt={r.name} />
        <div>
          <p>{r.name}</p>
          <p>{r.position}</p>
        </div>
      </div>
    </div>
  ));

  return (
    <div className={style.marquee}>
      <div className={style.track}>
        <div className={style.sequence}>{render()}</div>
        <div className={style.sequence} aria-hidden="true">{render()}</div>
      </div>
    </div>
  );
}